/**
 * Collection sort rules (2026-10-04):
 *  - "Featured" (manual) is the daily ranking and already puts sold-out pieces last.
 *  - Every other sort is computed by Shopify without regard to stock, so sold-out pieces
 *    flood page 1 (e.g. Traditional, price high-to-low: 19 of 24 sold out). Those sorts
 *    therefore always carry the storefront in-stock filter (filter.v.availability=1),
 *    which Shopify applies server-side, so pagination and counts stay correct. Shoppers
 *    can still untick it under Filter > Availability.
 * Runs in the capture phase so it replaces the theme's ajax sort handler with a plain
 * navigation that carries the extra parameter.
 */
(function () {
  if (window.__minakiSortInstock) return;
  window.__minakiSortInstock = true;
  var AVAIL = 'filter.v.availability';
  document.addEventListener('click', function (e) {
    var item = e.target.closest && e.target.closest('[data-sortby-item]');
    if (!item || !item.closest('.t4s-section-main, .t4s-collection-header, [data-minaki-plp-sticky]')) return;
    if (!/\/collections\//.test(location.pathname)) return;
    var value = item.getAttribute('data-value');
    if (!value) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var params = new URLSearchParams(location.search);
    params.set('sort_by', value);
    params.delete('page');
    params.delete(AVAIL);
    if (value !== 'manual') params.set(AVAIL, '1');
    location.assign(location.pathname.replace(/\/$/, '') + '?' + params.toString());
  }, true);
})();
